import { render, staticRenderFns } from "./PostPage.vue?vue&type=template&id=4204ed36&"
import script from "./PostPage.vue?vue&type=script&lang=js&"
export * from "./PostPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports